<template>
    <v-content>
        <v-container>
            <v-card>
                <v-card-title>
                    <v-icon>radio_button_checked</v-icon>
                    Incidencias:
                    <v-spacer/>
                    <v-text-field
                            v-model="search"
                            append-icon="search"
                            label="Buscar"
                            single-line
                            hide-details
                    />

                </v-card-title>
                <v-data-table
                        :headers="headers"
                        :items="incidences"
                        :items-per-page="5"
                        :search="search"
                        class="elevation-1"
                        ref="table"
                >
                    <template v-slot:item.createdAt="{ item }">
                       {{item.createdAt.toDate()  | moment('dddd, MMMM Do YYYY')}}
                    </template>
                    <template v-slot:item.user="{ item }">
                        {{getFullName(item.user)}}
                    </template>
                    <template v-slot:item.actions="{ item }">
                       <v-icon @click="opeModal(item)">fa-eye</v-icon>
                    </template>
                </v-data-table>
            </v-card>
            <v-dialog
                    v-model="dialog"
                    width="600"

            >
                <v-card>
                    <v-card-title class="text-center">Puntación del control</v-card-title>
                  <div class="container">
                      <v-row>
                          <v-col>
                              <v-text-field
                                     readonly
                                      v-model="control.armamento"
                                      label="Manejo de armamento"
                              />
                          </v-col>
                          <v-col>
                              <v-text-field
                                      readonly
                                      v-model="control.atencionCliente"
                                      label="Atención al cliente"
                              />
                          </v-col>
                      </v-row>

                      <v-row>
                          <v-col>
                              <v-text-field
                                      readonly
                                      v-model="control.conocimientoFyC"
                                      label="Conocimiento de funciones y consignas"
                              />
                          </v-col>
                          <v-col>
                              <v-text-field
                                      readonly
                                      v-model="control.minutasYlibros"
                                      label="Minuta y libros de control"
                              />
                          </v-col>
                      </v-row>

                      <v-row>
                          <v-col>
                              <v-text-field
                                      readonly
                                      v-model="control.cumplimientoControles"
                                      label="Cumplimiento de controles"
                              />
                          </v-col>
                          <v-col>
                              <v-text-field
                                      readonly
                                      v-model="control.elementoProteccion"
                                      label="Elementos de proteccion"
                              />
                          </v-col>
                      </v-row>

                      <v-row>
                          <v-col>
                              <v-text-field
                                      readonly
                                      v-model="control.presentacionP"
                                      label="Presentación personal"
                              />
                          </v-col>

                      </v-row>
                  </div>
                </v-card>
            </v-dialog>
        </v-container>
    </v-content>
</template>

<script>
    import {mapState} from "vuex";

    export default {
        name: "Incidences",
        data(){
            return{
                search:'',
                dialog:false,
                control:{},
                headers: [
                    {
                        text: 'Supervisor',
                        align: 'left',
                        sortable: true,
                        value: 'user',
                    },
                    { text: 'Vigilante', value: 'vigilante' },
                    { text: 'Tipo de vigilante', value: 'vigilante_type' },
                    { text: 'Turno de vigilante', value: 'vigilante_assignment' },
                    { text: 'Posición de vigilante', value: 'vigilante_position' },
                    { text: 'Creado', value: 'createdAt' },
                    { text: 'Opciones', value: 'actions', align: 'center' },
                    ],

            }
        },
        methods:{
            getFullName(value){
                return value.first_name +' '+ value.last_name
            },
            opeModal(value){
                this.dialog = true
                this.control = value
            }
        },
        computed:{
            ...mapState({
                incidences:state => state.incidence.incidences
            })
        }
    }
</script>

<style scoped>

</style>